import { useState } from 'react';

import { AddModel } from './AddModel';
import { ModelChoice } from './ModelChoice';

const ModelSettings = () => {
  const [isAddingModel, setIsAddingModel] = useState(false);

  const handleShowAddModel = () => {
    setIsAddingModel(true);
  };

  const handleCloseAddModel = () => {
    setIsAddingModel(false);
  };

  return (
    <div className="flex px-1 py-1" data-testid="model-settings-container">
      {!isAddingModel && <ModelChoice onShowAddModel={handleShowAddModel} />}
      {isAddingModel && <AddModel onCloseAddModel={handleCloseAddModel} />}
    </div>
  );
};
export default ModelSettings;
